import { withRouter } from "react-router";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { SeoRenderer } from "../../../common/helpers/seo";

import { changeStudentColors, changeStudentSolfaAudio, changeStudentPitchNotation, changeStudentRhythmSyllableTypes, changeStudentReversedToneset, changeStudentSolfaShort, changeStudentSolfaKam } from "../../store/user/actions";
import taskCompleted from "../../store/plan/actions/taskCompleted";
import { get, post } from "../../actions/general";

import loadableComponent from "./loadable";
import { Store } from "redux";
import { IUser } from "../../store/user/models";
import { IStateTree } from "../../store/interfaces";

const mapDispatchToProps = {
    get,
    post,
    taskCompleted,
    changeStudentColors,
    changeStudentPitchNotation,
    changeStudentRhythmSyllableTypes,
    changeStudentReversedToneset,
    changeStudentSolfaShort,
    changeStudentSolfaAudio,
    changeStudentSolfaKam,
};

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser
});

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(loadableComponent))),
    renderSeo: (store: Store, allMessage: { [key: string]: string }, lang: string) => {
        SeoRenderer({ title: allMessage["homework"], allMessage, lang });
    },
};
